import { datadogRum, type RumEvent } from "@datadog/browser-rum";

export const ddRum = datadogRum;

const MICROSOFT_LINK_SCANNER_ERROR = /Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+/;

const DROPPED_ERROR_SIGNATURES = [MICROSOFT_LINK_SCANNER_ERROR];

export const isDroppedRumEvent = (event: RumEvent): boolean =>
  event.type === "error" && DROPPED_ERROR_SIGNATURES.some((signature) => signature.test(event.error.message));

export const rumBeforeSend = (event: RumEvent): boolean => !isDroppedRumEvent(event);
